const inputLogin = {
  username: 'username',
  password: 'password',
};

export default inputLogin;
